/**
 * Latch marking "this session is ending" (logout, expiry, or page unload), so
 * the doomed requests a teardown produces do not each raise a toast.
 *
 * Dependency-free to keep the interceptor and the logout thunk cycle-free.
 */

let sessionEnding = false;

export const beginSessionEnd = (): void => {
  sessionEnding = true;
};

export const isSessionEnding = (): boolean => sessionEnding;

/** Logout can be an SPA navigation, so the latch must be cleared explicitly. */
export const resetSessionEnd = (): void => {
  sessionEnding = false;
};
